import { render } from "./PopupItem.vue?vue&type=template&id=471d5b52&scoped=true&lang=pug"
import script from "./PopupItem.vue?vue&type=script&lang=js"
export * from "./PopupItem.vue?vue&type=script&lang=js"

import "./PopupItem.vue?vue&type=style&index=0&id=471d5b52&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471d5b52"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QChip,QSeparator});
